/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

// Series colors, from the Full 2 design handoff. Their per-series assignment (in
// componentBreakDownProperties.js) is load-bearing: it keeps adjacent stack segments and pie slices
// distinguishable for colorblind viewers. Don't reassign them, and don't add brand or error reds
// (cardinal #8C191C, scarlet #C42B1C). Contrast on the white chart is noted for each.
export const COLOR_1 = '#2a78d6'; // blue, 4.4:1
export const COLOR_2 = '#eb6834'; // orange, 3.2:1
// The handoff's #1baf7a, a shade darker so it clears WCAG 1.4.11's 3:1 as a line.
export const COLOR_3 = '#1aa774'; // green, 3.1:1
export const COLOR_4 = '#eda100'; // amber, 2.2:1: for fills, last in the line cycle
export const COLOR_5 = '#e87ba4'; // pink, 2.7:1: for fills, last in the line cycle
export const COLOR_6 = '#008300'; // dark green, 5.0:1
export const COLOR_7 = '#4a3aa7'; // indigo, 8.6:1
export const COLOR_8 = '#e34948'; // coral red, 4.0:1
// Beyond the handoff's eight, for charts with more series: mid tones, so pie labels stay legible.
export const COLOR_9 = '#0b8fa8'; // cyan, 3.8:1
export const COLOR_10 = '#8a7f7b'; // warm gray, 3.9:1
export const COLOR_11 = '#b5835a'; // tan, 3.3:1
// The cycle for line-only charts (mode shapes, structural responses). Every color that clears 3:1
// as a line comes first; amber and pink come last, so a chart reaches them only past nine series.
export const COLORS = [
  COLOR_1,
  COLOR_2,
  COLOR_3,
  COLOR_8,
  COLOR_6,
  COLOR_7,
  COLOR_9,
  COLOR_10,
  COLOR_11,
  COLOR_4,
  COLOR_5,
];
